import { isDefined } from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import { Scan2Percentiles } from 'state/Constants/ScaleType';

import scope from './scope';

export default class Scan2Definition {
  #scan2CalcType;
  #percentiles;
  #calcType;

  constructor(props = {}) {
    const { scan2CalcType, percentiles, calcType } = props;
    this.#scan2CalcType = scan2CalcType;
    this.#percentiles = percentiles;
    this.#calcType = calcType;
  }

  get scan2CalcType() {
    return this.#scan2CalcType;
  }

  get percentiles() {
    return this.#percentiles;
  }

  get calcType() {
    return this.#calcType;
  }

  get key() {
    return `${scope} -  ${this.#scan2CalcType}, ${this.#percentiles}, ${this.#calcType}`;
  }

  get complete() {
    return isDefined(this.#scan2CalcType) && isDefined(this.#percentiles) && isDefined(this.#calcType);
  }

  static getDefault = () => new Scan2Definition({
    scan2CalcType: 'PARAM',
    percentiles: Scan2Percentiles[0],
    calcType: CalcType.Account,
  });

  copy = () => ({
    scan2CalcType: this.#scan2CalcType,
    percentiles: this.#percentiles,
    calcType: this.#calcType,

  });
  setScan2CalcType = (value) => new Scan2Definition({
    ...this.copy(),
    scan2CalcType: value,
  });
  setPercentiles = (value) => new Scan2Definition({
    ...this.copy(),
    percentiles: value,
  });
  setCalcType = (value) => new Scan2Definition({
    ...this.copy(),
    calcType: value,
  });
}
